import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SUPPORTED_LANGUAGES } from '../../types/language';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const getShortLabel = (lang: string) => {
    return lang === 'en' ? 'Eng' : 'Укр';
  };

  return (
    <div className="language-switcher">
      {Object.entries(SUPPORTED_LANGUAGES).map(([lang]) => (
        <button
          key={lang}
          onClick={() => setLanguage(lang as 'en' | 'uk')}
          className={`language-switcher-button ${
            language === lang ? 'active' : 'inactive'
          }`}
        >
          {getShortLabel(lang)}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;